import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../api';

export default function InformeIvaVerPage() {
  const { runId } = useParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [hasPdf, setHasPdf] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const [previewRes, runRes] = await Promise.all([
          api.get(`/informes-iva/preview/${runId}`, { responseType: 'text' }),
          api.get(`/informes-iva/run/${runId}?lite=1`).catch(() => ({ data: null }))
        ]);
        if (!cancelled) {
          setHtml(previewRes.data);
          setHasPdf(runRes.data?.run?.hasPdf !== false);
        }
      } catch (e) {
        if (!cancelled) toast.error(e.response?.data?.error || 'No se pudo cargar el informe');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [runId]);

  const descargarPdf = async () => {
    try {
      const res = await api.get(`/informes-iva/pdf/${runId}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `informe-iva-${runId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.response?.data?.error || 'PDF no disponible — use Imprimir y guardar como PDF');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 text-slate-600">
        Cargando informe…
      </div>
    );
  }

  if (!html) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6">
        <p>No se encontró el informe.</p>
        <Link to="/informes-iva" className="text-indigo-600 underline">
          Volver a Informes IVA
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-200">
      <div className="no-print sticky top-0 z-10 bg-white border-b border-slate-200 shadow-sm px-4 py-3 flex flex-wrap items-center gap-2">
        <Link to="/informes-iva" className="text-sm text-slate-600 hover:text-slate-900 mr-2">
          ← Volver
        </Link>
        <button
          type="button"
          onClick={descargarPdf}
          className="px-4 py-2 text-sm font-medium bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
        >
          Descargar PDF
        </button>
        <button
          type="button"
          onClick={() => window.print()}
          className="px-4 py-2 text-sm border border-slate-300 rounded-lg hover:bg-slate-50"
        >
          Imprimir / guardar PDF
        </button>
        {!hasPdf && (
          <span className="text-xs text-amber-700">Si no hay PDF, use Imprimir → Guardar como PDF.</span>
        )}
      </div>
      <iframe
        title="Informe IVA"
        srcDoc={html}
        className="flex-1 w-full min-h-[calc(100vh-56px)] bg-white border-0"
        sandbox="allow-same-origin"
      />
    </div>
  );
}
